import {request} from '../http';
import domain from '../domain';
import {getCookie} from '../util/cookie';

var searchwebService = function(){
    if(domain.env === 'online'){
        this.domain = '//searchweb.51tiangou.com';
    }else{
        this.domain = "//searchweb." + domain.env + ".66buy.com.cn";
    }
};
searchwebService.prototype._serviceAjaxCom = function(url,params){
    params.url = this.domain + url;
    return request(params);
};

// 查询商品分类情况
searchwebService.prototype.category = function (params) {
    params.type = 'GET';
    return this._serviceAjaxCom("/search/aggregation/market/category", params);
};


/**
 * 获取搜索联想词 跨境
 * */
searchwebService.prototype.queryOverseasCompleteWords = function(params){
    params.type = 'POST';

    return this._serviceAjaxCom('/search/oversea/queryCompleteWords', params);
};

/**
 * 获取搜索联想词 超市
 * */
searchwebService.prototype.queryMarketCompleteWords = function(params) {
    params.type = 'POST';

    return this._serviceAjaxCom('/search/market/queryCompleteWords', params);
};

/**
 * 获取搜索联想词 百货
 * */
searchwebService.prototype.queryMallCompleteWords = function(params){
    params.type = 'POST';

    return this._serviceAjaxCom('/search/mall/queryCompleteWords', params);
};

/**
 * 获取搜索联想词 购物
 * */
searchwebService.prototype.queryPlatformCompleteWords = function(params){
    params.type = 'POST';

    return this._serviceAjaxCom('/search/platform/queryCompleteWords', params);
};

/**
 * 过滤商品的参数，非购物页搜索。。。
 * */
searchwebService.prototype.aggregationFilter = function(params){
    params.type = 'POST';

    this._serviceAjaxCom('/search/aggregation/filter', params);
};

/**
 * 过滤商品的参数，购物页搜索。。。
 * */
searchwebService.prototype.aggregationPlatformFilter = function(params){
    params.type = 'POST';

    this._serviceAjaxCom('/search/aggregation/platform/filter', params);
};

/**
 * 搜索广告位，购物页面
 * */
searchwebService.prototype.adPlatform = function(params){
    params.type = 'GET';

    this._serviceAjaxCom('/ad/platform', params);
};

/**
 * 搜索广告位，海外购页面
 * */
searchwebService.prototype.adOversea = function(params){
    params.type = 'GET';

    this._serviceAjaxCom('/ad/oversea', params);
};

/**
 * 搜索广告位，超市门店页面
 * */
searchwebService.prototype.adMarket = function(params){
    params.type = 'GET';

    this._serviceAjaxCom('/ad/market', params);
};

/**
 * 搜索广告位，百货门店页面。
 * */
searchwebService.prototype.adMall = function(params){
    params.type = 'GET';

    this._serviceAjaxCom('/ad/mall', params);
};

/**
 * 搜索广告位，专柜特卖页面。
 * */
searchwebService.prototype.adCounterSale = function(params){
    params.type = 'GET';

    this._serviceAjaxCom('/ad/counterSale', params);
};

searchwebService.prototype.platCategoryAll = function(params){
    params.type = 'GET';

    this._serviceAjaxCom('/web/platCategory/all', params);
};
export default new searchwebService();
